<template>
	<div class="col-lg-3 col-md-3 col-sm-12">
		<!-- Fetch-Categories-from-Root-Category  -->
		<div class="redirect-link-wrapper mb-3" v-if="isAnyFilterSet()">
			<a class="redirect-link" href="#" @click="clearFilters()">Clear Filters</a>
		</div>
		<div class="fetch-categories" v-if="isShowMenuItem('categories')">
			<h3 class="title-name">Categories</h3>
			<!-- Level 3 -->
			<ul>
				<li v-for="category in getCategories" :key="category.id">
					<a
						:class="{active: selectedCategoryId == category.id}"
						href="#"
						@click.prevent="() => filterByCategoryId(category.id, category.category_slug)"
						>{{ category.name }}</a
					>
				</li>
			</ul>
			<!-- //end Level 3 -->
		</div>

		<div class="fetch-categories" v-if="isShowMenuItem('search_store')">
			<div class="text-center mb-2">
				<img
					:src="getStoreLogo()"
					alt=""
					height="100"
					width="100"
					class="rounded-circle"
					style="object-fit: cover"
				/>
			</div>
			<!-- <h3 class="title-name text-center">Search in {{ store_info.business_name }}</h3> -->
			<!-- Level 3 -->
			<ul>
				<li>
					<form action="" @submit.prevent="handleSearch">
						<div class="row">
							<div class="col-12">
								<input
									class="form-control"
									type="text"
									name=""
									id=""
									:placeholder="'Search in ' + store_info.business_name"
									required
									v-model="filters.search_store"
								/>
							</div>
							<div class="col-12">
								<button type="submit" class="button button-primary d-block w-100 mt-3 rounded">
									Search
								</button>
								<button
									v-if="filters.search_store"
									type="button"
									class="button button-primary d-block w-100 mt-3 rounded"
									@click="clearSearch"
								>
									Clear Search
								</button>
							</div>
						</div>
					</form>
				</li>
			</ul>
			<!-- //end Level 3 -->
		</div>

		<div class="fetch-categories" v-if="isShowMenuItem('brands')">
			<h3 class="title-name">Brands</h3>
			<!-- Level 3 -->
			<ul
				style="height: 200px; overflow: scroll"
				id="style-1"
				v-if="!getStatus.brands.loading"
			>
				<li
					v-for="brand in getBrands"
					:key="brand.id"
					:class="{active: filters.brandId == brand.id}"
				>
					<a href="#" @click.prevent="() => filterProductsByBrandId(brand.id)"
						>{{ brand.name }}
					</a>
				</li>
			</ul>
			<ul id="style-1" v-else>
				<li v-for="index in 6" :key="index">
					<content-loader
						:height="12"
						:width="200"
						:speed="1"
						:animate="true"
					></content-loader>
				</li>
			</ul>
			<!-- //end Level 3 -->
		</div>
		<!-- Filter-Rating -->
		<div class="facet-filter-by-rating" v-if="isShowMenuItem('rating')">
			<h3 class="title-name">Rating</h3>
			<div class="facet-form">
				<!-- 5 Stars -->
				<div class="facet-link">
					<StarRating
						:rating="filters.rating"
						:star-size="20"
						:show-rating="false"
						@update:rating="setRating"
					/>
				</div>
			</div>
		</div>
		<!-- Filter-Rating -->

		<div class="fetch-categories" v-if="isShowMenuItem('price_range')">
			<h3 class="title-name">Price Range</h3>
			<!-- Level 3 -->
			<ul>
				<li>
					<div class="row">
						<div class="col-6">
							<input
								class="form-control"
								type="number"
								name=""
								id=""
								v-model="filters.priceFrom"
								placeholder="from"
								required
							/>
						</div>
						<div class="col-6">
							<input
								class="form-control"
								type="number"
								name=""
								id=""
								placeholder="to"
								v-model="filters.priceTo"
								required
							/>
						</div>
						<div class="col-12">
							<button
								type="button"
								class="button button-primary d-block w-100 mt-3 rounded"
								@click="filterProducts"
							>
								Filter Products
							</button>
						</div>
					</div>
				</li>
			</ul>
			<!-- //end Level 3 -->
		</div>
		<!-- Filters /- -->
	</div>
</template>

<script>
	import {mapActions, mapGetters} from "vuex";
	import StarRating from "vue-star-rating";
	import {ContentLoader} from "vue-content-loader";
	export default {
		props: ["show", "store_info"],
		data() {
			return {
				filters: {
					priceFrom: "",
					priceTo: "",
					brandId: "",
					rating: 0,
					search_store: "",
				},
				brands: [],
				showBrandLess: false,
				selectedCategoryId: null,
			};
		},
		components: {StarRating, ContentLoader},
		computed: {
			...mapGetters("products", ["getProducts", "getStatus", "getBrands"]),
			...mapGetters("cat", ["getCategories"]),
		},

		methods: {
			isShowMenuItem(item) {
				if (!this.show) return true;
				return this.show.indexOf(item) != -1;
			},
			...mapActions("products", ["getProductByCategoryId", "fetchBrands"]),
			getStoreLogo() {
				return this.store_info.logo
					? process.env.VUE_APP_API_URL + this.store_info.logo
					: "http://placehold.jp/150x150.png";
			},
			//filter by Brands ID
			filterProductsByBrandId(brand_id) {
				this.filters.brandId = brand_id;
				let params = {
					...this.filters,
					id: this.$route.params.id,
					brandId: this.filters.brandId,
				};
				this.$emit("filterParams", params);
			},
			//filter By Price.
			filterProducts() {
				let params = {
					...this.filters,
					id: this.$route.params.id,
					priceFrom: this.filters.priceFrom,
					priceTo: this.filters.priceTo,
				};
				this.$emit("filterParams", params);
			},
			//filter by rating.
			setRating(rating) {
				this.filters.rating = rating;
				let params = {
					...this.filters,
					id: this.$route.params.id,
					rating: this.filters.rating,
				};
				this.$emit("filterParams", params);
			},
			filterByCategoryId(id, slug = null) {
				switch (this.$route.name) {
					case "Search":
						this.$router.push({
							name: "Search",
							query: {...this.$route.query, category_id: id},
						});
						break;
					case "Seller":
						this.$router.push({
							name: "Seller",
							query: {category_id: id},
						});
						break;
					default:
						this.$router.push({name: "ProductsByCategory", params: {id: id, slug: slug}});
						break;
				}
			},
			//for now i have handle brands limit here. in future we need to make it as resuable component (For Good Coding Practice) :)
			viewMoreBrands() {
				this.brands = this.getBrands;
				this.showBrandLess = true;
			},
			viewLessBrands() {
				this.brands = this.getBrands.slice(0, 3);
				this.showBrandLess = false;
			},
			handleSearch() {
				this.$emit("search_store", this.filters.search_store);
			},
			clearSearch() {
				this.filters.search_store = "";
				this.$emit("clear_store_search");
			},
			clearFilters() {
				this.filters.priceFrom = "";
				this.filters.priceTo = "";
				this.filters.brandId = "";
				this.filters.rating = 0;
				this.filters.search_store = "";
				// this.$emit("clear_filters");
			},
			isAnyFilterSet() {
				return (
					this.filters.priceFrom ||
					this.filters.priceTo ||
					this.filters.brandId ||
					this.filters.rating
				);
			},
		},
		watch: {
			$route(to, from) {
				//when id changes then we need to reset filter.
				if (to.params.id || to.query.category_id) {
					this.filters.brandId = "";
					this.filters.rating = 0;
					this.selectedCategoryId = to.params.id || to.query.category_id;
				} else {
					this.selectedCategoryId = null;
				}
			},
			getBrands(val) {
				//for intial load we need to get only 3,4 brands.
				// this.brands = val.slice(0, 6);
			},
		},
		mounted() {
			this.selectedCategoryId =
				this.$route.params.id || this.$route.query.category_id;
		},
	};
</script>

<style scoped>
	#style-1::-webkit-scrollbar-track {
		border-radius: 10px;
	}

	#style-1::-webkit-scrollbar {
		width: 8px;
		background-color: #f5f5f5;
	}

	#style-1::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #343a40;
	}
</style>
